export class DialogMessages {
  public service = 'dialog.service';
  public unavailableService = 'dialog.unavailable_service';
  public ok = 'general.ok';

  constructor() {
  }
}
